"use client";

import CompanyCard from "./companies/Card";
import InfiniteScroll from "@/components/InfiniteScroll";
import { Skeleton } from "@/components/ui/skeleton";
import HeaderDataCount from "@/components/views/common/HeaderDataCount";
import { useCompanies } from "@/hooks/use-companies";
import { useMemo } from "react";

export default function Companies({
  service,
  district,
  venue,
}: {
  service: string;
  district: string;
  venue: string;
}) {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useCompanies({ service, district, venue });

  const flatData = useMemo(() => {
    return data?.pages?.flatMap(page => page.response.data) || [];
  }, [data]);

  const summary = data?.pages?.[0]?.summary || null;

  if (isLoading) {
    return <CompanyLoading />;
  }
  
  return (
    <div className="container">
      <HeaderDataCount count={summary || {}} />

      <div className="py-4">
        <InfiniteScroll
          hasMore={hasNextPage}
          next={() => fetchNextPage()}
          loading={<CompanyLoading />}
          isLoading={isFetchingNextPage}
          skeletonElementId="company-card-skeleton"
          dataLength={flatData?.length || 0}
        >
          <section className="grid justify-items-center grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
            {flatData.map((item: any, index: number) => {
              return (
                <CompanyCard
                  {...item}
                  venue={{
                    id: item.venue?.id || 0,
                    title: item.venue?.title || '',
                  }}
                  key={item.id || index}
                />
              );
            })}
          </section>
        </InfiniteScroll>
      </div>
    </div>
  );
}

export function CompanyLoading() {
  return (
    <div
      id="company-card-skeleton"
      className="grid justify-items-center grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-5 gap-y-6 py-4"
    >
      {new Array(24).fill(0).map((_, index) => {
        return (
          <div
            className="flex justify-center gap-2 p-4 rounded-2xl border border-gray-secondary w-[389px] items-center"
            key={index}
          >
            <Skeleton className="w-[92px] h-[92px] rounded-2xl" />
            <Skeleton className="w-[213px] h-[40px] rounded-lg" />
            <Skeleton className="w-[34px] h-[26px] rounded-full" />
          </div>
        );
      })}
    </div>
  );
}
